const sortByUiPos = (a, b) => a.uiPos - b.uiPos;

export default sortByUiPos;
